import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { filesActionCreators } from '..';
import { uiActionCreators } from '../../ui';
import * as api from '../filesApi';

function* deleteSalesDocumentSaga(action: ReturnType<typeof filesActionCreators.deleteSalesDocument>) {
  yield put(uiActionCreators.showSpinnerDialog());
  try {
    yield* call(api.deleteSalesDocument, action.payload.uri);

    yield put(filesActionCreators.removeFile(action.payload.uri));
  } catch {
    //
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchDeleteSalesDocument() {
  yield takeEvery(filesActionCreators.deleteSalesDocument.match, deleteSalesDocumentSaga);
}
